<script lang="ts">
  type Props = { emoji: string };
  let { emoji }: Props = $props();

  let bgUrl = $state('');

  $effect(() => {
    const e = emoji.trim() || '🎉';
    const tile = document.createElement('canvas');
    tile.width = 220;
    tile.height = 220;
    const ctx = tile.getContext('2d');
    if (!ctx) return;
    const items = [
      { x: 28, y: 52, size: 32, rot: -18, op: 0.13 },
      { x: 140, y: 30, size: 24, rot: 25, op: 0.08 },
      { x: 95, y: 140, size: 28, rot: -8, op: 0.11 },
      { x: 185, y: 155, size: 20, rot: 35, op: 0.07 },
      { x: 50, y: 190, size: 18, rot: -30, op: 0.06 },
    ];
    for (const item of items) {
      ctx.save();
      ctx.globalAlpha = item.op;
      ctx.translate(item.x, item.y);
      ctx.rotate((item.rot * Math.PI) / 180);
      ctx.font = `${item.size}px "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", serif`;
      ctx.fillText(e, 0, 0);
      ctx.restore();
    }
    bgUrl = tile.toDataURL();
  });
</script>

<div class="bg" style="background-image: url({bgUrl})"></div>

<style>
  .bg {
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 0;
    background-repeat: repeat;
  }
</style>
